import { PendingDocumentMove } from "../../../api/ClientFileApi";

export const AssetInventoryMaxLength = {
  causesDescription: 4000,
  phoneNumber: 50,
  bankName: 255,
  incomings: 500,
} as const;

export interface AssetAccountFormValue {
  id: string | null;
  bankName: string | null;
  bankStreet: string | null;
  bankHouseNumber: string | null;
  bankZipCode: string | null;
  bankCity: string | null;
  bankCountry: string | null;
  iban: string | null;
  incomings: string | null;
  isOverdrawn: boolean | null;
  hasFurtherAccount: boolean | null;
}

export interface AssetPersonalDataFormValues {
  salutation: string;
  title: string | null;
  firstName: string;
  lastName: string;
  formerLastName: string | null;
  insuranceNumber: string | null;
  birthday: Date | null;
  placeOfBirth: string | null;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  country: string;
  employmentStatus: string;

  phoneNumber: string | null;
  causesDescription: string | null;
  hasOwnAccount: boolean | null;
  bankId: string | null;
  accounts: AssetAccountFormValue[];

  bankStatements: File[];
  /** Deferred drag-moves — internal app only; stays empty without the documentDnd slice. */
  documentMoves: PendingDocumentMove[];
}

export function createEmptyAccount(): AssetAccountFormValue {
  return {
    id: null,
    bankName: null,
    bankStreet: null,
    bankHouseNumber: null,
    bankZipCode: null,
    bankCity: null,
    bankCountry: null,
    iban: null,
    incomings: null,
    isOverdrawn: null,
    hasFurtherAccount: null,
  };
}
